import { CommonRequestResponseService } from './common-request-response.service';
import { CommonService } from 'app/services/common.service';
import { CommonAuthenticationService } from './common-authentication.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CollegeDetailService {

  currentCollegeId: number;
  currentStudentId: number;
  studentLocalId: number;
  studentDataId: number;
  parentStudentId: number;
  currentCollegeDetail: Observable<any>;
  partnerUserNToken = { userId: null, partnerId: null };

  constructor(private _commonAuthService: CommonAuthenticationService,
    private _commonService: CommonService,
    private _commonRequestResponseService: CommonRequestResponseService) { }
  genericSuccessFunction(data) {
    return data;
  }
  genericErrorFunction(error) {
    console.error(error);
  }

  getCurrentCollegeDetail(collegeId?: number): Observable<any> {
    if (collegeId && this.currentCollegeId && collegeId !== this.currentCollegeId) {
      this.setCurrentCollegeById(collegeId);
    }

    return this.getCollegeDetails();
  }

  setCurrentCollegeById(collegeId: number) {
    if (collegeId && collegeId > 0) {

      this.currentCollegeId = collegeId;
      const obj = { collegeData: collegeId };
      localStorage.setItem('collegeIdData', JSON.stringify(obj));
    }
  }

  setCollegePin(collegeId?: number, studentUserId?): Observable<any> {
    const inputJson = {
      collegeId: collegeId || this.currentCollegeId,
      studentUserId: studentUserId || JSON.parse(localStorage.getItem('studentLocalId'))
    };

    const onSuccess = (data: any) => {
      if (this.currentCollegeDetail) {
        // TODO: Look at typing this object better
        this.currentCollegeDetail['pinned'] = true;
        return data;
      }
    };

    return this.postWithHeader('college/pin', inputJson, onSuccess, this.genericErrorFunction);
  }

  removeCollegePin(collegeId?: number, studentUserId?): Observable<any> {
    const inputJson = {
      collegeId: collegeId || this.currentCollegeId,
      studentUserId: studentUserId || JSON.parse(localStorage.getItem('studentLocalId'))
    };
    const onSuccess = (data: any) => {
      if (this.currentCollegeDetail) {
        this.currentCollegeDetail['pinned'] = false;
        return data;
      }
    };
    return this.postWithHeader('college/unpin', inputJson, onSuccess, this.genericErrorFunction);
  }

  getCollegeList(data) {
    const inputJson = Object.assign(data, this.partnerUserNToken) as any;
    return this.postWithHeader('college/collegelist', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  getClusterCareers(inputJson) {
    return this.postWithHeader('College/Clustercareers', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  getProfileCollegeSearch(criteria) {
    const inputJson = Object.assign(criteria, this.partnerUserNToken) as any;
    return this.postWithHeader('College/GetProfileCollageSearch', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  getMajorCareers(inputJson) {
    return this.postWithHeader('college/majorcareers', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  getMajorsCareers(inputJson) {
    return this.postWithHeader('college/majorscareers', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  atAGlance(inputJson) {
    return this.postWithHeader('college/ataglance', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  search(inputJson) {
    return this.postWithHeader('college/search', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  transfers(inputJson) {
    return this.postWithHeader('college/transfers', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  admissions(inputJson) {
    return this.postWithHeader('college/admissions', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  location(inputJson) {
    return this.postWithHeader('college/location', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  sports(inputJson) {
    return this.postWithHeader('college/sports', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  supportservices(inputJson) {
    return this.postWithHeader('college/supportservices', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  statistics(inputJson) {
    return this.postWithHeader('college/statistics', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  financialStatistics(inputJson) {
    return this.postWithHeader('college/financial/statistics', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  general(inputJson) {
    return this.postWithHeader('college/financial/general', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  profileSaveCollageSearch(inputJson) {
    return this.postWithHeader('College/ProfileSaveCollageSearch', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  getCollegeNames(inputJson) {
    return this.postWithHeader('college/collegeNames', inputJson, this.genericSuccessFunction, this.genericErrorFunction);
  }

  setCollegeData(data) {
    this.currentCollegeDetail = data;
  }

  getCollegeData() {
    return this.currentCollegeDetail;
  }

  postWithHeader(url, inputJson, onSuccess?, onFail?) {
    return this._commonRequestResponseService.postWithHeader(url, inputJson)
      .map((data: any) => {
        return onSuccess(data);
      }, (error) => {
        onFail()
      })
  }

  private getCollegeDetails() {
    this.studentLocalId = JSON.parse(localStorage.getItem('studentLocalId'));
    this.parentStudentId = JSON.parse(localStorage.getItem('parentStudentId'));
    const userId = +this._commonAuthService.getLoginData().userId;
    const role = this._commonAuthService.getLoginData().role.toLowerCase();
    const path = localStorage.getItem('collegeSearchPath');
    if (role === 'super coach' && path === 'coachStudentDetail') {
      this.studentDataId = this.studentLocalId;
    }
    if (role === 'super coach' && path === 'collegeSearch') {
      this.studentDataId = userId;
    }
    if (role === 'email coach' && path === 'coachStudentDetail') {
      this.studentDataId = this.studentLocalId;
    }
    const studentData = this._commonService.getDataWithoutObservable('recentStudentDetail');
    const inputJson = {
      collegeId: this.currentCollegeId,
      studentUserId: role === 'student' ? userId : role === 'parent' ? this.parentStudentId : this.studentDataId
    };

    this.currentCollegeDetail = this._commonRequestResponseService.postWithHeader('college/collegeDetails', inputJson).map((data: any) => data.items[0]);
    return this.currentCollegeDetail;
  }


}
